import { CheckCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
import React from "react";
import { TimestampView } from "../components/common/TimestampView";
import { HTMLProps } from "../model/HTMLProps";
import { OfferingCommonDetails } from "./Offering";

interface OfferingPublishStatusBadgeProps extends HTMLProps {
  offering: OfferingCommonDetails;
}
export function OfferingPublishStatusBadge(
  props: OfferingPublishStatusBadgeProps
) {
  return (
    <span className={props.className}>
      {!props.offering.publishedAt && (
        <Tag icon={<ClockCircleOutlined />} color="default">
          <span className="fs-14">Draft</span>
        </Tag>
      )}
      {props.offering.publishedAt && (
        <Tooltip
          title={
            <>
              Published at{" "}
              <TimestampView timestamp={props.offering.publishedAt} />
            </>
          }
        >
          <Tag icon={<CheckCircleOutlined />} color="success">
            <span className="fs-14">Published</span>
          </Tag>
        </Tooltip>
      )}
    </span>
  );
}
